/* eslint-disable */
import React, {Component} from 'react'
import Loader from '../loaders/loader'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import http from '../Interceptor/Interseptor'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'
import $ from 'jquery'
import {Link} from 'react-router-dom'
import HeaderGrid from '../Pagination/HeaderGrid'
import jMoment from 'moment-jalaali'

class TerminalHistory extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      terminalHis: [],
      lengthTerminalHis: 0,
      printInfo: [],
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'occurredTime_desc',
      getSort: '',
      // selectedDateFrom: moment(),
      // selectedDateTo: null,
      // modal: false,
      // providers: [],
      // selectedOption: [],
      // wareHousesname: [],
      // providerText: "",
      // wareTextPrint: "",
      // finalTarikh: "",
      // buttonClicked: false,
      // warehouseId: "",
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه ترمینال',
          value: 'terminalCode',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'از',
          value: 'fromName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'به',
          value: 'toName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان انتصاب',
          value: 'occurredTime',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: ' اوپراتور',
          value: 'operatorName',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }
  componentDidMount() {
    this.getTerminalHietory()
  }

  getTerminalHietory = () => {
    let data = {
      pageSize: this.state.pageSize,
      pageNumber: this.state.pageNumber,
      sortBy: this.state.sortBy,
      export: false
    }

    http
      .get(`${BASE_MANAGE.BASE_MANAGE_PAYMENT_GET_HISTORY_LIST_TERMINAL}`, {
        params: data
      })
      .then((res) => {
        if (res.data.error === null) {
          $('.showBaseTable').fadeIn()
          this.setState({
            terminalHis: res.data.object.result,
            lengthTerminalHis: res.data.object.countAll
          })
          console.log(JSON.stringify(res))
        } else {
          $('.showBaseTable').fadeOut()
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getTerminalHietory()
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getTerminalHietory()
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getTerminalHietory()
    }
  }

  render() {
    let {pageNumber, pageSize, loading, terminalHis} = this.state
    let {selectedOption} = this.state
    const {selectedDateTo} = this.state

    // let excelColumns = [
    //     { title: "تاریخ ثبت", value: "confirmDate" },
    //     { title: "کد محصول", value: "productCode" },
    //     { title: "نام محصول", value: "productName" },
    //     { title: "تعداد وارد شده", value: "inQuantity" },
    //     { title: "تعداد خارج شده", value: "outQuantity" },
    //
    //     { title: "تامین کننده", value: "providerName" }
    // ];
    // let columns = [
    //     "ردیف",
    //     "تاریخ ثبت",
    //     "شماره سراسری سند",
    //     "تاریخ دستی",
    //     "کد محصول",
    //     "بارکد محصول",
    //     "نام محصول",
    //     "نام انبار",
    //     "وارد شده",
    //     "خارج شده",
    //     "مانده",
    //
    //     "ماهیت انبار",
    //     "تامین کننده"
    // ];

    return (
      <div className="rtl">
        <Loader show={loading} />
        {/*<div className="printSection">*/}
        {/*    <table*/}
        {/*        className="printTable printReportTable"*/}
        {/*        ref={node => (this.printPart = node)}*/}
        {/*    >*/}
        {/*        <HeaderTablePrint*/}
        {/*            header="گزارش کاردکس"*/}
        {/*            headerColSpan={15}*/}
        {/*            reporter={name}*/}
        {/*            timePrint={jMoment().format("jYYYY/jM/jD HH:mm")}*/}
        {/*            leftColSpan={4}*/}
        {/*            rightColSpan={5}*/}
        {/*            centerColSpan={6}*/}
        {/*            centerSection={"تامین کننده : " + this.state.providerText}*/}
        {/*            rightSection={"موجودی برای انبار : " + this.state.wareTextPrint}*/}
        {/*            columns={columns}*/}
        {/*        />*/}
        {/*        <thead></thead>*/}
        {/*        <tbody>*/}
        {/*        {this.state.printInfo.map((cardex, index) => (*/}
        {/*            <tr key={"i" + index}>*/}
        {/*                <td>{index + 1}</td>*/}
        {/*                <td>*/}
        {/*                    {jMoment(cardex.confirmDate).format("jYYYY/jMM/jDD HH:mm")}*/}
        {/*                </td>*/}
        {/*                <td>{cardex.globalDocNo}</td>*/}
        {/*                <td>*/}
        {/*                    {cardex.manualRegisterDate == null*/}
        {/*                        ? "-"*/}
        {/*                        : jMoment(cardex.manualRegisterDate).format(*/}
        {/*                            "jYYYY/jMM/jDD HH:mm"*/}
        {/*                        )}*/}
        {/*                </td>*/}
        {/*                <td>{cardex.articleId}</td>*/}
        {/*                <td>{cardex.productCode}</td>*/}
        {/*                <td>{cardex.productName}</td>*/}
        {/*                <td>{cardex.warehouseName}</td>*/}
        {/*                <td>{cardex.inQuantity}</td>*/}
        {/*                <td>{cardex.outQuantity}</td>*/}
        {/*                <td>{cardex.remainQuantity}</td>*/}

        {/*                <td>{cardex.input ? "وارده" : "صادره"}</td>*/}
        {/*                <td>{cardex.providerName}</td>*/}
        {/*            </tr>*/}
        {/*        ))}*/}
        {/*        </tbody>*/}
        {/*    </table>*/}
        {/*</div>*/}

        {/*<div className="excelSection">*/}
        {/*    <ExcelExport*/}
        {/*        dir="rtl"*/}
        {/*        ref={exporter => {*/}
        {/*            this._export = exporter;*/}
        {/*        }}*/}
        {/*        fileName="گزارش کاردکس"*/}
        {/*    >*/}
        {/*        <grid style={{ height: "420px" }} data={this.state.excelReport}>*/}
        {/*            <gridColumn*/}
        {/*                key={"confirmDate"}*/}
        {/*                field={"confirmDate"}*/}
        {/*                title={"تاریخ ثبت سند"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"globalDocNo"}*/}
        {/*                field={"globalDocNo"}*/}
        {/*                title={"شماره سراسری سند"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"manualRegisterDate"}*/}
        {/*                field={"manualRegisterDate"}*/}
        {/*                title={"تاریخ دستی سند"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"articleId"}*/}
        {/*                field={"articleId"}*/}
        {/*                title={"کد محصول"}*/}
        {/*                width="100px"*/}
        {/*                footerCellOptions={{ wrap: true, textAlign: "center" }}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"productCode"}*/}
        {/*                field={"productCode"}*/}
        {/*                title={"بارکد"}*/}
        {/*            />*/}

        {/*            <gridColumn*/}
        {/*                key={"productName"}*/}
        {/*                field={"productName"}*/}
        {/*                title={"نام محصول"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"warehouseName"}*/}
        {/*                field={"warehouseName"}*/}
        {/*                title={"نام انبار"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"inQuantity"}*/}
        {/*                field={"inQuantity"}*/}
        {/*                title={"وارد شده"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"outQuantity"}*/}
        {/*                field={"outQuantity"}*/}
        {/*                title={"خارج شده"}*/}
        {/*            />*/}
        {/*            <gridColumn*/}
        {/*                key={"remainQuantity"}*/}
        {/*                field={"remainQuantity"}*/}
        {/*                title={"مانده"}*/}
        {/*            />*/}

        {/*            <gridColumn key={"input"} field={"input"} title={"ماهیت  سند"} />*/}
        {/*            <gridColumn*/}
        {/*                key={"providerName"}*/}
        {/*                field={"providerName"}*/}
        {/*                title={"تامین کننده"}*/}
        {/*            />*/}
        {/*        </grid>*/}
        {/*    </ExcelExport>*/}
        {/*</div>*/}

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>تاریخچه انتصاب ترمینال ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                {/*<button className="filterBtn">*/}
                {/*    <i className="fa fa-search"></i>*/}
                {/*</button>*/}
                {/*<button*/}
                {/*    className={"printButton"}*/}
                {/*    disabled={this.state.buttonClicked ? false : true}*/}
                {/*    onClick={this.exportExcel}*/}
                {/*>*/}
                {/*    <i className="fas fa-file-excel"></i>*/}
                {/*</button>*/}
                {/*<button*/}
                {/*    className="printButton"*/}
                {/*    disabled={this.state.buttonClicked ? false : true}*/}
                {/*    onClick={this.exportPrint}*/}
                {/*>*/}
                {/*    <i className="fas fa-print"></i>*/}
                {/*</button>*/}
              </div>
            </div>
            {/*<div className="basketFilterComponent">*/}
            {/*    <div className="filterInputs">*/}
            {/*<div className="formComponent">*/}
            {/*<label>تاریخ تا:</label>*/}

            {/*<MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">*/}
            {/*    <DatePicker*/}
            {/*        okLabel="تأیید"*/}
            {/*        cancelLabel="لغو"*/}
            {/*        autoOk={true}*/}
            {/*        leftArrowIcon={<Icon type="left" />}*/}
            {/*        rightArrowIcon={<Icon type="right" />}*/}
            {/*        labelFunc={date =>*/}
            {/*            date == null ? "" : date.format("jYYYY/jMM/jDD")*/}
            {/*        }*/}
            {/*        onChange={this.handleDateChangeTo}*/}
            {/*        TextFieldComponent={this.toDate}*/}
            {/*        id="datePickerTo"*/}
            {/*        name="datePickerTo"*/}
            {/*        value={selectedDateTo}*/}
            {/*        ref={node => (this.toDateInput = node)}*/}
            {/*    />*/}
            {/*</MuiPickersUtilsProvider>*/}
            {/*</div>*/}
            {/*        <div className="formComponent">*/}
            {/*            <label>کد ترمینال:</label>*/}
            {/*            <input*/}
            {/*                className="form-control"*/}
            {/*                type="text"*/}
            {/*                id="terminalCode"*/}
            {/*            />*/}
            {/*        </div>*/}

            {/*    </div>*/}
            {/*    <div className="filterOption">*/}
            {/*        <button*/}
            {/*            // className="confirmFilter"*/}
            {/*            // onClick={this.filter.bind(this)}*/}
            {/*        >*/}
            {/*            جست و جو*/}
            {/*        </button>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="showBaseTable print">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                {this.state.terminalHis.map((terminal, index) => (
                  <tr key={index}>
                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td>{terminal.terminalCode}</td>
                    <td>{terminal.fromName}</td>
                    <td>{terminal.toName}</td>
                    <td>{jMoment(terminal.occurredTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                    <td>{terminal.operatorName}</td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthTerminalHis}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TerminalHistory
